import { ChartBoxMultipleOutlineIcon } from './ChartBoxMultipleOutlineIcon';

/**
 * author: Konstantin Saller
 * id DA461BDE-F579-4196-A3CD-C186D0C2912A
 * name chart-box-multiple-outline
 * version: 7.4.47
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-box-multiple-outline.svg
 * tags
 * - Math 
 */
export const WidgetBoxMultipleOutlineIcon = ChartBoxMultipleOutlineIcon;
export default WidgetBoxMultipleOutlineIcon